import React, { Fragment, useEffect, useState } from "react";
import styles from "./DoctorAvailableSlotPicker.module.css";
import fetchMethod from "../Methods/FetchFunc";
import moment from "moment-timezone";
import { withAuth0 } from "@auth0/auth0-react";
import { API_URL, WORKFLOW_FILTER } from "../../ConstVariable";
import axios from "axios";

async function fetchWithTimeout(resource, options = {}) {
  const { timeout = 8000 } = options;

  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  const response = await fetch(resource, {
    ...options,
    signal: controller.signal,
    credentials: "include"
  });
  clearTimeout(id);
  return response;
}

const DoctorAvailableSlotPicker = ({
  GetAuthToken,
  date,
  selectedDoctor,
  setSelectedTimeSlot,
  selectedTimeSlot,
  setSelectedDoctorIdBySlot,
  setSelectedDateBySlot,
  setSelectedTimeBySlot,
  clickedFetchButton,
  centerId,
  setSelectedData,
  Index,
  fromDate,
  toDate,
}) => {
  const [availableDate, setAvailableDate] = useState("");
  const [fetchingData, setFetchingData] = useState(null);
  const [availableSlots, setAvailableSlots] = useState([]);

  //To check , did we get an error or not during to fetch the available slots
  const [getAnError, setGetAnError] = useState({
    error_code: 0,
    error_description: "",
  });
  const DOCTOR_AVAILABLE_ON_DATE = `${API_URL}/oi/api/v2/doctorAvailableOnDate`;

  useEffect(() => {
    return () => {
      setAvailableSlots([]);
    };
  }, [selectedDoctor, fromDate, toDate]);

  const getDoctorAvailableSlots = async () => {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "short",
      day: "numeric",
    };
    let DateFormat = new Date(date);
    setFetchingData(true);
    DateFormat = DateFormat.toLocaleDateString(undefined, options);
    let splitDate = DateFormat.split(",");
    setAvailableDate(`${splitDate[1]}, ${splitDate[0]}`);
    setAvailableSlots([]);
    let Data = {
      date: date,
      doctor_pms_ref_id: selectedDoctor,
      siteId: centerId,
    };
    let token = localStorage.getItem("MyToken");

    setGetAnError({
      error_code: 0,
      error_description: "",
    });

    let timeout = (Index + 1) * 250;
    setTimeout(async () => {
      // const controller = new AbortController();
      // const timeoutId = setTimeout(() => controller.abort(), 500);
      try {
        axios({
              method: "post",
              url: DOCTOR_AVAILABLE_ON_DATE,
              data: Data,
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              timeout:10000,
              withCredentials: true
            }).then((response) => {
              setFetchingData(false);
              const {error_code,error_description ,data} = response.data
              
              if(response?.data?.error_code===0){
        
                if ( data?.slots_in_time_ranges && Array.isArray(data?.slots_in_time_ranges) ) {
                  data.slots_in_time_ranges.forEach((item) =>
                  setAvailableSlots((prevState) => [...prevState, ...item.slots])
                  );
                }
                
              }
                setGetAnError({
                  error_code: error_code, error_description: error_description
                })}).catch ((error)=>{
                  
                    setFetchingData(false);

                    if (error.message.includes('10000ms')){
                      setGetAnError({
                        error_code: 201, error_description: 'Time out error occurred. Unable to fetch the slot details.'
                      })
                    }else{
                      setGetAnError({
                        error_code: 201, error_description: error.message
                      })
                    }
              
                   
                    console.log("Error", error.message, error.name);
                  }) 
        
      } catch (error) {
        if (error.name === "AbortError") {
          setGetAnError({
            error_code: 201,
            error_description: "API timeout Error.",
          });
        }
        console.log(error.name === "AbortError",error.name );
      } finally {
        // clearTimeout(timeoutId);
      }
    }, timeout);
  };

  useEffect(async () => {
    getDoctorAvailableSlots();

    return () => {
      setAvailableSlots([]);
    };
  }, [date, clickedFetchButton]);

  const onClickTimeSlotHandler = (slot) => {
    let id = `${slot.doctor_pms_ref_id}-${slot.slot_scheduletime}`;
    setSelectedTimeSlot(id);
    setSelectedDoctorIdBySlot(slot.doctor_pms_ref_id);
    let slot_scheduletime = slot.slot_scheduletime.split(" ");
    let Date = moment(slot.slot_scheduletime, "YYYY-MM-DD HH:mm");
    let dateFormat = moment(Date).format("DD-MM-YYYY HH:mm");
    let Time = moment(slot_scheduletime[1], "HH:mm");
    setSelectedDateBySlot(moment(dateFormat, "DD-MM-YYYY HH:mm"));
    setSelectedTimeBySlot(Time);
    setSelectedData(slot);
  };

  let renderedDate = () => {
    if (fetchingData) {
      return (
        <div className={styles.doctorAvailableSlotPicker__loadingData}>
          loading available slots....
        </div>
      );
    } else if (
      availableSlots.length != 0 &&
      fetchingData != null &&
      !fetchingData
    ) {
      return (
        <Fragment>
          <div className={styles.doctorAvailableSlotPicker__slots}>
            {availableSlots &&
              availableSlots.map((slot) => {
                let id = `${slot.doctor_pms_ref_id}-${slot.slot_scheduletime}`;
                return (
                  <div
                    className={styles.doctorAvailableSlotPicker__slot}
                    style={{
                      backgroundColor: id === selectedTimeSlot && "#296997",
                      color: id === selectedTimeSlot && "white",
                    }}
                    onClick={() => onClickTimeSlotHandler(slot)}
                  >
                    {slot.slot_time}
                  </div>
                );
              })}
          </div>
        </Fragment>
      );
    } else if (getAnError.error_code !== 0 && getAnError.error_description) {
      //showin an error if unable to get the data due to error
      return (
        <div
          className={styles.doctorAvailableSlotPicker__noSlots}
          style={{ color: "#FF8800", fontWeight: "normal" }}
        >
          {getAnError.error_description}
        </div>
      );
    } else {
      return (
        <div className={styles.doctorAvailableSlotPicker__noSlots}>
          No slots available
        </div>
      );
    }
  };

  return (
    <div className={styles.doctorAvailableSlotPicker}>
      <div className={styles.doctorAvailableSlotPicker__date}>
        {availableDate}
      </div>

      {renderedDate()}
    </div>
  );
};

export default DoctorAvailableSlotPicker;
